"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdminConsole = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const web_socket_context_1 = require("../../web-socket/web-socket-context");
function useAdminConsole() {
    const { client, subscribe, unsubscribe } = react_1.useContext(web_socket_context_1.WebsocketContext);
    const resultForm = react_1.useRef(null);
    const [loading, setLoading] = react_1.useState(false);
    const handleSubmit = event_callback_hook_1.useEventCallback((values) => {
        var _a;
        setLoading(true);
        const resultSubscription = subscribe('/topic/script/execute/response', (message) => {
            unsubscribe(resultSubscription);
            unsubscribe(consoleSubscription);
            handleResultIncomming(message);
            setLoading(false);
        });
        const consoleSubscription = subscribe('/topic/script/execute/out', (message) => {
            handleConsoleIncomming(message);
        });
        (_a = client.current) === null || _a === void 0 ? void 0 : _a.publish({
            destination: '/app/script/execute/request',
            body: JSON.stringify(values),
            skipContentLengthHeader: true,
        });
    });
    const handleResultIncomming = event_callback_hook_1.useEventCallback((message) => {
        var _a, _b;
        const result = JSON.parse(message.body);
        if (result.error != null) {
            (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('result', result.error);
        }
        else {
            (_b = resultForm.current) === null || _b === void 0 ? void 0 : _b.setFieldValue('result', JSON.stringify(result.result));
        }
    });
    const handleConsoleIncomming = event_callback_hook_1.useEventCallback((message) => {
        var _a, _b;
        const values = (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.getFieldValues();
        (_b = resultForm.current) === null || _b === void 0 ? void 0 : _b.setFieldValue('console', values.console + message.body);
    });
    const handleLogIncomming = event_callback_hook_1.useEventCallback((message) => {
        var _a, _b;
        const values = (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.getFieldValues();
        (_b = resultForm.current) === null || _b === void 0 ? void 0 : _b.setFieldValue('log', values.log + message.body);
    });
    const handleClear = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.clearForm();
    });
    react_1.useEffect(() => {
        const subscription = subscribe('/topic/script/log', (message) => handleLogIncomming(message));
        return () => {
            unsubscribe(subscription);
        };
    }, [handleLogIncomming, subscribe, unsubscribe]);
    return {
        handleSubmit,
        handleClear,
        resultForm,
        loading,
    };
}
exports.useAdminConsole = useAdminConsole;
//# sourceMappingURL=admin-console-hook.js.map